<template>
  <div>
    <Header></Header>
    <section class="startegy">
       <div class="main-section main_opening">
         <div class="container-fluid">
            <h1 class="text-center" v-html="this.strategy.main_upper_section.main_heading"></h1>
         </div>
        <div class="p-relative static_title">
            <div class="titleTwo">
                <div class="container">
                    <div class="row">
                        <div class="col-6 text-left">
                            {{this.strategy.main_upper_section.first_label_heading}}
                        </div>
                        <div class="col-6 text-right">
                            {{this.strategy.main_upper_section.second_label_heading}}
                        </div>
                    </div>
                </div>
            </div>
         <div class="container p-relative">
            <div class="row feature_boxes">
                <div class="col-md-6 text-left">
                    <div class="mt-20 mb-20 d-md-none d-block">
                        <h2 class="text-white">{{this.strategy.main_upper_section.first_label_heading}}</h2>
                    </div>
                    <div class="feature-box mb-30">
                        <div class="icon">
                            <img src="@/assets/images/icon/icon1.svg" alt="" class="img-fluid" />
                        </div>
                        <div class="feature">
                            <p class="name labels d-flex" ><span class="number">{{this.strategy.main_upper_section.boxes[0].label.number}}</span><span v-html="this.strategy.main_upper_section.boxes[0].label.small_label"></span></p>
                            <div class="text">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[0].content}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="feature-box mb-130">
                        <div class="icon">
                            <img src="@/assets/images/icon/icon2.svg" alt="" class="img-fluid" />
                        </div>
                        <div class="feature">
                            <p class="name labels d-flex"><span class="number">{{this.strategy.main_upper_section.boxes[1].label.number}}</span><span v-html="this.strategy.main_upper_section.boxes[1].label.small_label"></span> </p>
                            <div class="text">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[1].content}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="feature-box mb-30 mt-30 pt-20">
                        <div class="icon">
                            <img src="@/assets/images/icon/icon3.svg" alt="" class="img-fluid" />
                        </div>
                        <div class="feature">
                            <p class="name labels d-flex"><span class="number">{{this.strategy.main_upper_section.boxes[2].label.number}}</span><span v-html="this.strategy.main_upper_section.boxes[2].label.small_label"></span></p>
                            <div class="text">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[2].content}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="feature-box mb-30">
                        <div class="icon">
                            <img src="@/assets/images/icon/icon4.svg" alt="" class="img-fluid" />
                        </div>
                        <div class="feature">
                            <p class="name labels d-flex"><span class="number">{{this.strategy.main_upper_section.boxes[3].label.number}}</span><span v-html="this.strategy.main_upper_section.boxes[3].label.small_label"></span></p>
                            <div class="text">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[3].content}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <div class="mt-20 mb-20 d-md-none d-block">
                        <h2 class="text-white text-md-right text-left">{{this.strategy.main_upper_section.second_label_heading}}</h2>
                    </div>
                    <div class="feature-box mb-30"> 
                        <div class="feature ">
                            <p class="name labels d-flex"><span v-html="this.strategy.main_upper_section.boxes[4].label.small_label"></span> <span class="number">{{this.strategy.main_upper_section.boxes[4].label.number}}</span></p>
                            <div class="text ">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[4].content}}</p>
                            </div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/images/icon/icon5.svg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    <div class="feature-box mb-200"> 
                        <div class="feature ">
                            <p class="name labels d-flex"><span v-html="this.strategy.main_upper_section.boxes[5].label.small_label"></span><span class="number">{{this.strategy.main_upper_section.boxes[5].label.number}}</span></p>
                            <div class="text ">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[5].content}}</p>
                            </div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/images/icon/icon6.svg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    <div class="feature-box mb-30 mt-30 "> 
                        <div class="feature ">
                            <p class="name labels d-flex"><span v-html="this.strategy.main_upper_section.boxes[6].label.small_label"></span><span class="number">{{this.strategy.main_upper_section.boxes[6].label.number}}</span></p>
                            <div class="text ">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[6].content}}</p>
                            </div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/images/icon/icon7.svg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    <div class="feature-box mb-30"> 
                        <div class="feature ">
                            <p class="name labels d-flex"><span v-html="this.strategy.main_upper_section.boxes[7].label.small_label"></span><span class="number">{{this.strategy.main_upper_section.boxes[7].label.number}}</span></p>
                            <div class="text ">
                              <p class="text-white">{{this.strategy.main_upper_section.boxes[7].content}}</p>
                            </div>
                        </div>
                        <div class="icon">
                            <img src="@/assets/images/icon/icon8.svg" alt="" class="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="scroll-icons" @click="scroll_main">
                    <div class="scroll_svg_section">
                        <div class="scroll-text">{{$t("labels.explore")}}</div>
                            <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                        </div>
                    </div>
            </div>
         </div>
         </div>
      </div>
      <div class="startegy_main_content">
        <div class="slide-section">
          <div class="upperText">
            <!-- <div class="startegy-title">
              <h4>STRATEGY</h4>
            </div> -->
          </div>
          <div class="main-slides">
            <VueSlickCarousel
              v-bind="sliderSettingsmain"
              @init="onInitCarousel"
              @afterChange="onAfterChange"
              @beforeChange="onBeforeChange"
              ref="carousel"
            >
              <div class="slide slide-1" id="1" data-theme="dark">
                <div class="slide__image overlay">
                  <img
                    src="@/assets/images/banners/strategy-banner.jpg"
                    alt=""
                  />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title">
                        {{this.strategy.sight.heading}}
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section" @click="this.scrollTop">
                        <div class="scroll-text">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slide slide-2" id="2" data-theme="dark">
                <div class="slide__image overlay">
                  <img
                    src="@/assets/images/banners/strategy-banner.jpg"
                    alt=""
                  />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title" v-html="this.strategy.sustainableFurture.heading">
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section" @click="this.scrollTop">
                        <div class="scroll-text" @click="this.scrollTop">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slide slide-3" id="3" data-theme="light">
                <div class="slide__image">
                  <img
                    src="@/assets/images/banners/evaluation-banner.jpg"
                    alt=""
                  />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title" >{{this.strategy.telcoevelution[0].title}}
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section"  @click="this.scrollTop">
                        <div class="scroll-text" @click="this.scrollTop">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slide slide-4" id="4" data-theme="light">
                <div class="slide__image">
                  <img
                    src="@/assets/images/banners/strategy-slider-3.png"
                    alt=""
                  />
                </div>
                <div class="slide__contents">
                  <div class="Slide-container">
                    <div class="main-content">
                      <!-- <div class="report-title">
                        Annual Report 2020
                      </div> -->
                      <div class="main-title"  v-html="strategy.Zain_gruop.slideTitle">
                      </div>
                    </div>
                    <div class="scroll-icons">
                      <div class="scroll_svg_section"  @click="this.scrollTop">
                        <div class="scroll-text" @click="this.scrollTop">
                          {{$t("labels.explore")}}
                        </div>
                        <div class="scroll-svg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="43"
                            height="43"
                            viewBox="0 0 43 43"
                          >
                            <g
                              id="Group_1"
                              data-name="Group 1"
                              transform="translate(-665 -1023)"
                            >
                              <g
                                id="Ellipse_1"
                                data-name="Ellipse 1"
                                transform="translate(665 1023)"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                              >
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="21.5"
                                  stroke="none"
                                />
                                <circle
                                  cx="21.5"
                                  cy="21.5"
                                  r="20.75"
                                  fill="none"
                                />
                              </g>
                              <path
                                id="Polygon_1"
                                data-name="Polygon 1"
                                d="M4.5,0,9,5H0Z"
                                transform="translate(691 1048) rotate(180)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
            <div class="slider__nav">
              <button @click.prevent="slidePrev" class="slider__nav--previous" :class="{disabled:isFirst}">
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 87.5 66"
                >
                  <use xlink:href="#custom_left_arrow"></use>
                </svg>
              </button>
              <button @click.prevent="slideNext" class="slider__nav--next" :class="{disabled:isLast}" >
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 87.5 66"
                >
                  <use xlink:href="#custom_right_arrow"></use>
                </svg>
              </button>
            </div>
          </div>
          <div class="section_footer">
            <div class="innerFooter">
              <div class="innerlink" >
                <a href="#" @click.prevent="slidePrev" :class="{disabled:isFirst}">{{$t("labels.previous")}}</a>
              </div>
              <div class="innerlink">
                <a href="#" @click.prevent="slideNext" :class="{disabled:isLast}">{{$t("labels.next")}}</a>
              </div>
              <div class="innerlink scroll_top">
                <a href="#" @click="this.scrollFullTop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43">
                        <use xlink:href="#circle-arrow-down"></use> 
                    </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll_section_content">
          <div class="scrollSection _4SIGHT_content" data-slide="1">
            <div class="title-slide-content">
              <div class="slide_title">
                <h3>{{this.strategy.sight.heading}}</h3>
              </div>
            </div>
            <div class="row main_text_content">
              <!-- <div class="col-lg-6 mx-auto">
                <span class="unde-title">OUR SERVICES</span>
                <div class="margin-bottom">
                  <div class="innercontent">
                    <p>
                      transform and digitize touchpoints and channels have
                      resulted in an advanced capability to service customers
                      amid lockdowns and restrictions.
                    </p>
                  </div>
                </div>
                <div class="margin-bottom">
                  <div class="innercontent">
                    <p class="font-weight-bold">transform</p>
                    <p class="font-weight-bold">
                      and digitize touchpoints and channels have resulted in an
                      advanced capability to service customers amid lockdowns
                      and restrictions.
                    </p>
                  </div>
                </div>
              </div> -->
              <div class="col-lg-12 mx-auto">
                <!-- <div class="section_title_under">
                  <h5>Zain’s growth strategy</h5>
                </div> -->
                <div class="section_main-content">
                  <p v-for="(text,index) in this.strategy.sight.content" :key="index+'5454'">{{text}}</p>
                </div>
                <!-- <div class="section_title_under">
                  <h5>4Sight</h5>
                </div> -->
                <div class="section_main-content">
                 
                </div>
              </div>
            </div>
          </div>
          <div class="scrollSection creating_digital_future" data-slide="2">
            <div class="container">
              <h3>
                {{this.strategy.sustainableFurture.title}}
              </h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="section-heading" v-html="this.strategy.sustainableFurture.leftsubtitle"></div>
                  <div class="category"  v-for="(items,index) in this.strategy.sustainableFurture.rightline" :key="index+'540465'">
                    <span class="icon" v-html="items.icon">
                    </span>
                    <div class="text">
                      <span class="num">
                        {{items.num}}
                      </span>
                      <div class="name" v-html="items.text"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 rev">
                  <div class="section-heading" v-html="this.strategy.sustainableFurture.rightsidetitle"></div>
                  <div class="category"  v-for="(items,index) in this.strategy.sustainableFurture.leftline" :key="index+'1122'">
                    <span class="icon" v-html="items.icon">
                    </span>
                    <div class="text">
                      <span class="num" >
                        {{items.num}}
                      </span>
                      <div class="name" v-html="items.text"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="scrollSection creating_digital_future evolution-telco"
            data-slide="3"
          >
            <div class="container">
              <div class="row">
                <div class="col-lg-12 border-right-grey">
                  <h3>{{this.strategy.telcoevelution[0].title}}</h3>
                  <p v-for="(txt,index) in this.strategy.telcoevelution[0].text" :key="index+'11220'">
                    {{txt}}
                  </p>
                  <div class="evolution-wrapper"  v-for="(items,index) in this.strategy.telcoevelution[0].boxes" :key="index+'112201'">
                    <div class="category" >
                      <span class="icon" v-html="items.icon">
                      </span>
                      <div class="text">
                        <span class="num" >
                         {{items.num}}
                        </span>
                        <div class="name" v-html="items.text"></div>
                      </div>
                    </div>
                    <div class="descripton">
                      <p v-for="(content,index) in items.contents" :key="index+'112202'">{{content}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 rev">
                <h3>{{this.strategy.telcoevelution[1].title}}</h3>
                  <p  v-for="(txt,index) in this.strategy.telcoevelution[1].text" :key="index+'112203'">{{txt}}</p>
                  <div class="evolution-wrapper" v-for="(items,index) in this.strategy.telcoevelution[1].boxes" :key="index+'782565125'">
                    <div class="category">
                       <span class="icon" v-html="items.icon">
                      </span>
                       <div class="text">
                        <span class="num">
                          {{items.num}}
                        </span>
                        <div class="name" v-html="items.text"></div>
                      </div>
                    </div>
                    <div class="descripton">
                      <p v-for="(content,index) in items.contents" :key="index+'112233'">{{content}}
                      </p>
                    </div>
                  </div>
                  <div class="evolution-wrapper">
                    <div class="category">
                        <span class="icon" v-html=" this.strategy.telcoevelution[1].boxes2[0].icon">
                      </span>
                       <div class="text">
                        <span class="num">
                          {{this.strategy.telcoevelution[1].boxes2[0].num}}
                        </span>
                        <div class="name" v-html="this.strategy.telcoevelution[1].boxes2[0].text"></div>
                      </div>
                    </div>
                    <div class="descripton">
                     <p v-for="content in this.strategy.telcoevelution[1].boxes2[0].contents" :key="content+'f'">{{content}}
                      </p>
                      <div  class="company-logo">
                        <img  src="@/assets/images/logos/tamam.png" alt="" />
                      </div>
                      <h5>{{strategy.telcoevelution[1].boxes2[0].heading1}}</h5>
                      <p v-for="(cont,index) in strategy.telcoevelution[1].boxes2[0].content" :key="index+'1122334'">
                        {{cont}}
                      </p>
                      <div class="company-logo">
                        <img :src="require(`@/assets/images/logos/${strategy.telcoevelution[1].boxes2[0].image2}`)" alt="" />
                      </div>
                      <h5>{{strategy.telcoevelution[1].boxes2[0].heading2}}</h5>
                      <p v-for="(cont,index) in strategy.telcoevelution[1].boxes2[0].content2" :key="index+'11223341'">
                        {{cont}}
                      </p>
                      <div class="company-logo">
                        <img :src="require(`@/assets/images/logos/${strategy.telcoevelution[1].boxes2[0].image2}`)" alt="" />
                      </div>
                      <h5>{{strategy.telcoevelution[1].boxes2[0].heading3}}</h5>
                      <p v-for="(cont,index) in strategy.telcoevelution[1].boxes2[0].content3" :key="index+'445712'">
                        {{cont}}
                      </p>
                    </div>
                  </div>
                  <div class="evolution-wrapper">
                    <div class="category">
                      <span class="icon" v-html=" strategy.telcoevelution[1].boxes2[1].icon">
                       
                      </span>
                      <div class="text">
                        <span class="num">
                          {{strategy.telcoevelution[1].boxes2[1].num}}
                        </span>
                        <div class="name" v-html="strategy.telcoevelution[1].boxes2[1].text"></div>
                      </div>
                    </div>
                    <div class="descripton">
                       <p v-for="content in this.strategy.telcoevelution[1].boxes2[1].contents" :key="content+'f'">{{content}}
                      </p>
                      <div class="company-logo">
                        <img :src="require(`@/assets/images/logos/${strategy.telcoevelution[1].boxes2[1].image}`)" alt="" />
                      </div>
                      <h5 v-html="strategy.telcoevelution[1].boxes2[1].heading1"></h5>
                      <p v-for="(text,index) in strategy.telcoevelution[1].boxes2[1].content" :key="index+'654054'">{{text}}</p>
                      <div  class="company-logo">
                        <img :src="require(`@/assets/images/logos/${strategy.telcoevelution[1].boxes2[1].image2}`)" alt="" />
                      </div>
                      <h5>{{strategy.telcoevelution[1].boxes2[1].heading2}}</h5>
                      <p v-for="(text,index) in strategy.telcoevelution[1].boxes2[1].content2" :key="index+'445842'">
                        {{text}}
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="scrollSection group_invistment zainDigital" data-slide="4">
            <div class="title-slide-content">
              <div class="slide_title mt-20">
                <h3 v-html="strategy.Zain_gruop.slideTitle"></h3>
              </div>
            </div>
            <div class="main_text_content">
              <div class="under_small-content spacing_custom">
                <p v-for="text in strategy.Zain_gruop.slideContent[0]" :key="text+'354'" v-html="text"></p>
              </div>
              <div class="spanCounter spacing_custom">
                <div class="counter_title logo">
                  <span>{{strategy.Zain_gruop.counter[0].title}}</span>
                  <div>
                    <img :src="require(`@/assets/images/logos/${strategy.Zain_gruop.counter[0].title_image}`)" alt="">
                  </div>

                </div>
                <div class="counter_main-content">
                  <p v-for="text in strategy.Zain_gruop.counter[0].description" :key="text+'6840248'">{{text}}</p>
                </div>
                <h3>{{strategy.Zain_gruop.counter[0].small_title}}</h3>
                <div class="counter_main-content">
                  <p>{{strategy.Zain_gruop.counter[0].small_para}}</p>
                </div>
                <div class="commitment">
                  <div class="title">{{strategy.Zain_gruop.counter[0].table_title}}</div>
                  <div class="commitment-wrapper">
                      <ul v-for="(list,index) in strategy.Zain_gruop.counter[0].table" :key="index+'640666'">
                        <li><img :src="require(`@/assets/images/logos/${list.left_image}`)" alt=""></li>
                        <li v-html="list.right_content"></li>
                      </ul>
                  </div>
                  <div class="values">
                      <ul>
                        <li v-for="(data_list,index) in strategy.Zain_gruop.counter[0].second_table" :key="index+'785622365'" v-html="data_list"></li>
                      </ul>
                  </div>
                </div>
              </div>
              <div class="spanCounter spacing_custom">
                <div class="counter_title logo">
                  <span>{{strategy.Zain_gruop.counter[1].title}}</span>
                  <div>
                    <img :src="require(`@/assets/images/logos/${strategy.Zain_gruop.counter[1].title_image}`)" alt="">
                    {{strategy.Zain_gruop.counter[1].label}}
                  </div>

                </div>
                <div class="counter_main-content">
                  <p v-for="text in strategy.Zain_gruop.counter[1].description" :key="text+'65026405'">
                    {{text}}
                  </p>
                </div>
                <div class="socialMedia-handles values">
                    <ul >
                        <li v-for="(social,index) in strategy.Zain_gruop.counter[1].social" :key="index+'56625265'">
                          <i :class="social.icon" class="fab"></i>
                          {{social.title}}
                          <span>{{social.counter}}</span>
                        </li>
                    </ul>
                </div>
              </div>
              <div class="spanCounter spacing_custom">
                <div class="justify_content">
                    <div class="counter_title">
                      {{strategy.Zain_gruop.counter[2].title}}
                    </div>
                    <div class="content-logo">
                      <img :src="require(`@/assets/images/logos/${strategy.Zain_gruop.counter[2].image}`)" alt="" />
                  </div>
                </div>
                <div class="counter_main-content">
                  <p>{{strategy.Zain_gruop.counter[2].desc}}</p>
                </div>
              </div>
              <div class="spanCounter spacing_custom">
                <div class="counter_title">
                  {{strategy.Zain_gruop.counter[3].title}}
                </div>
                <div class="counter_main-content">
                  <p v-for="(text,index) in strategy.Zain_gruop.counter[3].desc" :key="index+'656506540'" v-html="text"></p>
                </div>
                <div class="partners">
                    <ul>
                      <li>
                        <img src="@/assets/images/partners/docomodigital_logoSymbol.png" alt="">
                      </li>
                      <li>
                        <img src="@/assets/images/partners/digital virgo.png" alt="">
                      </li>
                      <li>
                        <img src="@/assets/images/partners/apple.png" alt="">
                      </li>
                    </ul>
                    <ul>
                      <li><img src="@/assets/images/partners/centi.png" alt=""></li>
                      <li><img src="@/assets/images/partners/zain kids.png" alt=""></li>
                    </ul>
                    <ul>
                      <li><img src="@/assets/images/partners/play vod.png" alt=""></li>
                      <li><img src="@/assets/images/partners/zain games.png" alt=""></li>
                    </ul>
                    <ul>
                      <li><img src="@/assets/images/partners/google.png" alt=""></li>
                      <li><img src="@/assets/images/partners/gamemine.png" alt=""></li>
                      <li><img src="@/assets/images/partners/osn.png" alt=""></li>
                    </ul>
                    <ul>
                      <li><img src="@/assets/images/partners/1200px-Starzplay-logo.svg.png" alt=""></li>
                    </ul>
                    <ul>
                      <li><img src="@/assets/images/partners/CODASHOP-LOGO.png" alt=""></li>
                      <li><img src="@/assets/images/partners/being.png" alt=""></li>
                    </ul>
                </div>
              </div>
            </div>
            <div class="shapes_content">
              <div class="row">
                <div class="custom_padd col-lg-6">
                  <div class="underSection">
                    <div class="image_sec">
                      <div class="main_svg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="140.46"
                          height="139.972"
                          viewBox="0 0 140.46 139.972"
                        >
                          <use xlink:href="#connection-icon"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="content_section">
                      <div class="main_title">
                         {{strategy.Zain_gruop.counter[3].boxes[0].title}}
                      </div>
                      <div class="under_small-text">
                        {{strategy.Zain_gruop.counter[3].boxes[0].small_text}}
                      </div>
                      <div class="under_small-content">
                        <p>{{strategy.Zain_gruop.counter[3].boxes[0].desc}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="custom_padd col-lg-6">
                  <div class="underSection">
                    <div class="image_sec">
                      <div class="main_svg svg_img">
                        <svg style="fill:#c4a2fc;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Layer_1" data-name="Layer 1" viewBox="0 0 55.1 58.01"><g class="cls-2"><path class="cls-3" d="M39.6,30.28l-4.53,4.55,0,.05a1.79,1.79,0,0,1-2.55,0,1.82,1.82,0,0,1,0-2.56L35.76,29l-3.25-3.28A1.88,1.88,0,0,1,32,24.61a1.81,1.81,0,0,1,1.62-2h.19a1.76,1.76,0,0,1,1.29.56l4.53,4.55a1.81,1.81,0,0,1,0,2.55m-9.14-5.19-2.34,8.79a1.09,1.09,0,0,1-.05.17,1.8,1.8,0,1,1-3.43-1.12L27,24.15a1.8,1.8,0,0,1,1.65-1.36h.17a2,2,0,0,1,.41.06,1.82,1.82,0,0,1,1.24,2.24M22.58,35a1.79,1.79,0,0,1-2.54-.2l-4.53-4.55a1.81,1.81,0,0,1,0-2.55L20,23.18a1.74,1.74,0,0,1,1.23-.55,1.8,1.8,0,0,1,1.33.54,1.81,1.81,0,0,1,0,2.56L19.33,29l3.25,3.27a1.8,1.8,0,0,1,.2.19,1.83,1.83,0,0,1-.2,2.56M54.2,37h0l-5.3-3.08A22.68,22.68,0,0,0,49.63,29h0a22,22,0,0,0-.74-4.91L54.19,21a1.83,1.83,0,0,0,.67-2.48l-4.62-8a1.8,1.8,0,0,0-2.46-.67h0L42.23,13A21.81,21.81,0,0,0,34,8.24V1.81A1.81,1.81,0,0,0,32.18,0H22.92a1.8,1.8,0,0,0-1.79,1.81V8.24A21.93,21.93,0,0,0,12.87,13L7.33,9.81a1.79,1.79,0,0,0-2.46.67L.24,18.54A1.82,1.82,0,0,0,.9,21l5.3,3.08A22,22,0,0,0,5.48,29h0a22.07,22.07,0,0,0,.73,4.91L.9,37a1.82,1.82,0,0,0-.66,2.48l4.63,8.05a1.79,1.79,0,0,0,2.46.67L12.87,45a21.85,21.85,0,0,0,8.26,4.78v6.42A1.81,1.81,0,0,0,22.92,58h9.26A1.82,1.82,0,0,0,34,56.19V49.77A22,22,0,0,0,42.23,45l5.54,3.22a1.81,1.81,0,0,0,2.47-.66h0l4.62-8.05A1.82,1.82,0,0,0,54.2,37" transform="translate(0 0)"/></g></svg>
                      </div>
                    </div>
                    <div class="content_section">
                      <div class="under_small-text no-margin">{{strategy.Zain_gruop.counter[3].boxes[1].small_text}}</div>
                      <div class="main_title">
                        {{strategy.Zain_gruop.counter[3].boxes[1].title}}
                      </div>
                      <div class="under_small-text">
                        {{strategy.Zain_gruop.counter[3].boxes[1].label}}
                      </div>
                      <div class="under_small-content">
                        <p>{{strategy.Zain_gruop.counter[3].boxes[1].desc}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="custom_padd col-lg-6">
                  <div class="underSection">
                    <div class="image_sec">
                      <div class="main_svg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="128.074"
                          height="129.885"
                          viewBox="0 0 128.074 129.885"
                        >
                          <use xlink:href="#custom_settings"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="content_section">
                      <div class="main_title">
                        70 MILLION
                      </div>
                      <div class="under_small-text">
                        TRANSACTIONS PROCESSED
                      </div>
                      <div class="under_small-content">
                        <p>Since the launch of the Zain group API platform</p>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="shapes_content">
              <div class="row justify-content-center">
                
                <div class="custom_padd col-lg-8">
                  <div class="underSection">
                    <div class="image_sec">
                      <div class="main_svg svg_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="62.89"
                          height="102.5"
                          viewBox="0 0 62.89 102.5"
                        >
                          <use xlink:href="#lovation_icon"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="content_section">
                      <div class="main_title">
                        7 {{$t("labels.Countries")}}
                      </div>
                      <div class="under_small-text">
                       {{strategy.Zain_gruop.counter[3].boxes[2].small_label}}
                      </div>
                      <div class="under_small-content">
                        <ul>
                          <li>
                            <div class="countery-years">
                              <div class="year">
                                2018
                              </div>
                              <div class="all_country">
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/kuwait.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/saudia.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/jordan.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="under_country-text">
                                 3 {{$t("labels.Countries")}}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="countery-years">
                              <div class="year">
                                2019
                              </div>
                              <div class="all_country">
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/kuwait.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/saudia.png"  
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/jordan.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/iraq.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/bharain.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/oman.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="under_country-text">
                                 6 {{$t("labels.Countries")}}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="countery-years">
                              <div class="year">
                                2020
                              </div>
                              <div class="all_country">
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/kuwait.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/saudia.png"  
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/jordan.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/iraq.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/bharain.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/oman.png"
                                    alt=""
                                  />
                                </div>
                                <div class="country_icon">
                                  <img
                                    src="@/assets/images/country_flags/sudan.png"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="under_country-text">
                                 7 {{$t("labels.Countries")}}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div class="countery-years">
                              <div class="year">
                                2021
                              </div>
                              <div class="all_country">
                                <div class=" under_country-text">
                                  {{strategy.Zain_gruop.counter[3].boxes[2].last_text}}
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import VueSlickCarousel from "vue-slick-carousel";
import data from '@/components/strategy/json/strategy.json';
import strategy from '@/mixin/strategy.js';
import util from '@/mixin/util.js';
export default {
  name: "strategy",
  components: {
    VueSlickCarousel,
  },
  mixins: [strategy, util],
  data() {
    return {
       totalSlides: 4,
        isFirst: true,
        isLast: false,
        strategy:data,
        sliderSettingsmain: {
        slidesToShow: 1,
        slideToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        draggable: false,
        swipe:false,
        rtl: this.$i18n.locale=="en" ? false : true,
        cssEase: "ease-in",
        speed: 1000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              draggable: true,
              swipe:true,
            }
          },
        ]
      },
    };
  },
  mounted() {
    //this.gsapAnimation();
    this.Contents();
    this.counterAnimation();
  },
   created(){
      if(this.$i18n.locale=="en"){
            this.strategy = data.en;
        }
        else{
            this.strategy = data.ar;    
        }
    },
  methods: {
    
    onInitCarousel() {
        this.sliderInit();
    },
   onAfterChange(currentSlide, slick) {
      
    },
    onBeforeChange(slick, currentSlide, nextSlide) {
        this.changeTheme();
        let ns = currentSlide;
        ns >0 ? this.isFirst=false : this.isFirst=true;
        ns < this.totalSlides -1 ? this.isLast=false : this.isLast=true;
    },
    slidePrev() {
      this.$refs.carousel.prev();
      var section_height =  document.querySelector('.main_opening').offsetHeight;
      document.body.scrollTop = section_height;
      document.documentElement.scrollTop = section_height;
    },
    slideNext() {
      this.$refs.carousel.next();
      var section_height =  document.querySelector('.main_opening').offsetHeight;
      document.body.scrollTop = section_height;
      document.documentElement.scrollTop = section_height;
    },
    scroll_main(){
        var section_height =  document.querySelector('.main_opening').offsetHeight;
        document.body.scrollTop = section_height;
        document.documentElement.scrollTop = section_height;
    }
  },
};
</script>
<style lang="scss" scoped>
.main_opening{
    background-image: url("../assets/images/banners/strategy-main-banner1.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position:center center;
    @media screen and (max-width:575px){
      background-image: url("../assets/images/banners/main-content-mob.jpg");
    }
}
@import "@/assets/sccs/strategy.scss";
p{
  text-align: left;
}
.light-Slide {
  .upperText {
    .startegy-title {
      h4 {
        color: black !important;
      }
      &::before {
        background: black !important;
      }
      &::after {
        background: black !important;
      }
    }
  }
  .Slide-container {
    div {
      color: #000 !important;
      &::before {
        background: black;
      }
    }
  }
  .scroll_svg_section {
    svg {
      g {
        stroke: black;
      }
    }
  }
  .slider {
    &__nav {
      button {
        color: #000;
        &:hover {
          background: unset;
          color: black;
        }
      }
    }
  }
  .scroll-svg {
    color: #000;
  }
}
/deep/ {
  #chart {
    margin-top: rem(40px);
  }
  .report-title {
    margin-left: 60px;
    position: relative;
    top: -42px;
  }
//    .slider {
//     &__nav {
//       bottom: 50%;
//       transform: translateY(50%);
//       width: 100%;
//       button {
//         position: absolute;
//         width: 80px;
//         height: 80px;
//         background: none;
//         border: none;
//         border-radius: unset;
//         display: flex;
//         flex-wrap: wrap;
//         align-items: center;
//         justify-content: center;
//         color: #fff;
//         svg {
//           width: 100% !important;
//           @media screen and (max-width:991px){
//             width:80% !important;
//           }
//         }
//         &:hover {
//           background: unset;
//           color: #fff;
//         }
//       }
//       &--previous {
//         left: 35px;
//       }
//       &--next {
//         right: 35px;
//       }
//       svg {
//         transform: unset;
//         margin: unset;
//       }
//       @media screen and (max-width: 1199px) {
//         &--previous {
//           left: 30px;
//         }
//         &--next {
//           right: 30px;
//         }
//       }
//       @media screen and (max-width:991px){
//           bottom: 50%;
//            &--next {
//             right: 0px;
//             top: 60px;
//           }
//           &--previous{
//             right:0;
//             left:auto;
//           }
//       }
//     }
//   }
}
@media screen and (max-width: 767px){
    .startegy{
        .slide-1{
            .slide__image{
                img{
                    object-position: right top;
                }
            }
        }
    }
}
[lang="ar"]{
  .startegy{
    /deep/{
      // .slick-slider { direction: rtl; }
      // .slick-slide{float: right;}
      // .slick-track {left: 0;right: auto;}
    }
  }
}

// arsal changes
</style>
